import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";
import { useCommentsContainer } from "@/react/components/CommentsCompass/CommentsContainer";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import { useModerationInfoModal } from "@/react/components/ModerationInfo/ModerationInfoModal";
import { settingsPath } from "@/react/helpers/urlHelpers/settingsPath";
import type { Comment } from "@/react/types/Comment";
import { COMMENT_TYPE } from "@/react/types/FlaggedContent";

interface ModerationBannerProps {
  comment: Comment;
}

export const ModerationBanner = ({ comment }: ModerationBannerProps) => {
  const moderationModal = useModerationInfoModal();
  const { isNarrow } = useCommentsContainer();
  const { isEmbedded } = useCommentsConfig();

  const handleReviewClick = () => {
    if (isEmbedded) {
      window.open(
        settingsPath.moderationDashboard.index(),
        "_blank",
        "noreferrer",
      );
      return;
    }

    void moderationModal.show({
      flaggedContentId: String(comment.id),
      flaggedContentType: COMMENT_TYPE,
    });
  };

  return (
    <Alert
      icon="triangle-exclamation-filled"
      iconColor="warning"
      variant="warning"
      layout={isNarrow ? "vertical" : "horizontal"}
      title={t("comments.moderation_banner.title")}
      description={t("comments.moderation_banner.description", {
        count: comment.unresolved_flagged_reports_count,
      })}
      primaryActionProps={{
        children: t("comments.moderation_banner.review"),
        onClick: handleReviewClick,
      }}
    />
  );
};
